import { Github, Linkedin, Mail } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer
      style={{
        borderTop: '1px solid var(--border)',
        padding: '2.25rem 4rem',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: '1rem',
        background: 'var(--bg)',
      }}
    >
      <div
        className="font-mono-custom gradient-text"
        style={{ fontSize: '1rem', fontWeight: 700 }}
      >
        Guptaraj Shrestha
      </div>
      <div style={{ fontSize: '0.8rem', color: 'var(--text2)' }}>
        © {currentYear} · Code. Create. Evolve.
      </div>
      <div style={{ display: 'flex', gap: '0.9rem' }}>
        {[
          { href: 'https://github.com/guptarajStha', Icon: Github, label: 'GitHub' },
          { href: 'https://www.linkedin.com/in/guptaraj-shrestha-a813481a6/', Icon: Linkedin, label: 'LinkedIn' },
          { href: 'mailto:guptarajshrestha@gmail.com', Icon: Mail, label: 'Email' },
        ].map(({ href, Icon, label }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            style={{
              width: 36, height: 36, borderRadius: '50%',
              border: '1px solid var(--border)', background: 'var(--card)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'var(--text2)', textDecoration: 'none',
              transition: 'all 0.3s', cursor: 'none',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.color = 'var(--accent)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--text2)'; e.currentTarget.style.transform = ''; }}
          >
            <Icon size={16} />
          </a>
        ))}
      </div>
    </footer>
  );
}
